import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    teams: [],
    branches: [],
    stationTeams: [],
    totalEmployees: null,
    employees: [],
    editTeamData: [],
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    filterValue: null,
    totalTeams: null,
  },
  actions,
  mutations,
};
